// file: SideNav.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Drawer, IconButton, Tooltip, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import kt from "../../../assests/logo tansparent.svg";
import krihaTeamsWordmark from "../../../assests/text transparent.png";
import {
  Menu as MenuIcon,
  KeyboardArrowUp,
  KeyboardArrowDown,
  DashboardOutlined,
  TaskOutlined,
  AssignmentTurnedInOutlined,
  BeachAccessOutlined,
  DateRangeOutlined,
  StoreOutlined,
  HandshakeOutlined,
  AccountBalanceWalletOutlined,
  AssignmentOutlined,
  TextureOutlined,
  PaletteOutlined,
  ViewKanbanOutlined,
  ShoppingCartOutlined,
  FolderOutlined,
  NotificationsOutlined,
  BarChartOutlined,
  PeopleOutlined,
  HistoryOutlined,
  SettingsOutlined,
} from "@mui/icons-material";
import {
  manufacturerNavigations,
  findActiveNavItem,
  isLinkActive,
  filterNavigationsByAccessControl,
} from "../../../NavigationData";
import styles from "./sideNav.module.scss";
import useLogout from "../../../auth/useLogout";
import LogoutModal from "../logoutModal/LogoutModal";

const CollapseToggleIcon = ({ isCollapsed, strokeColor = "white" }) => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      transform: isCollapsed ? "rotate(180deg)" : "none",
      transition: "transform 180ms ease",
    }}
  >
    <path
      d="M23.0003 23.0006L17 17.0003L23.0003 11"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.0003 23.0006L11 17.0003L17.0003 11"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// lab_profile has no MUI icons-material equivalent, so it's inlined
// directly rather than rendered via the ligature font.
const LabProfileIcon = () => (
  <svg width="24" height="24" viewBox="0 -960 960 960" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M320-480v-80h320v80H320Zm0-160v-80h320v80H320Zm-80 240h300q29 0 54 12.5t42 35.5l84 110v-558H240v400Zm0 240h442L573-303q-6-8-14.5-12.5T540-320H240v160Zm480 80H240q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h480q33 0 56.5 23.5T800-800v640q0 10-.5 20t-1.5 20q-9-2-18.5-3t-19.5-1q-11 0-21 1t-21 3q1-10 1.5-19.5t.5-20.5v-189l-240-90-240 90v189q0 121 68 220t172 132q21-7 41-17t39-23v94q-19 10-39 17.5T480-80Zm194 0q-14 0-24-10t-10-24v-132q0-14 10-24t24-10h6v-40q0-33 23.5-56.5T760-400q33 0 56.5 23.5T840-320v40h6q14 0 24 10t10 24v132q0 14-10 24t-24 10H674Zm46-200h80v-40q0-17-11.5-28.5T760-360q-17 0-28.5 11.5T720-320v40Z" />
  </svg>
);

// shield_locked has no MUI icons-material equivalent, so it's inlined
// directly rather than rendered via the ligature font.
const ShieldLockedIcon = () => (
  <svg width="24" height="24" viewBox="0 -960 960 960" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M480-480Zm0 400q-139-35-229.5-159.5T160-516v-244l320-120 320 120v244q0 10-.5 20t-1.5 20q-9-2-18.5-3t-19.5-1q-11 0-21 1t-21 3q1-10 1.5-19.5t.5-20.5v-189l-240-90-240 90v189q0 121 68 220t172 132q21-7 41-17t39-23v94q-19 10-39 17.5T480-80Zm194 0q-14 0-24-10t-10-24v-132q0-14 10-24t24-10h6v-40q0-33 23.5-56.5T760-400q33 0 56.5 23.5T840-320v40h6q14 0 24 10t10 24v132q0 14-10 24t-24 10H674Zm46-200h80v-40q0-17-11.5-28.5T760-360q-17 0-28.5 11.5T720-320v40Z" />
  </svg>
);


const TicketIcon = () => (
  <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.0498 12.0371L8.9998 10.5559L10.9498 12.0371L10.1998 9.65586L12.1498 8.09961H9.76987L8.9998 5.73711L8.22974 8.09961H5.8498L7.7998 9.65586L7.0498 12.0371ZM3.1498 14.3996C2.77855 14.3996 2.46074 14.2677 2.19637 14.0038C1.93199 13.7399 1.7998 13.4227 1.7998 13.0522V10.7786C1.7998 10.6551 1.83999 10.5472 1.92037 10.455C2.00074 10.3626 2.10405 10.3049 2.2303 10.2817C2.5058 10.1895 2.72793 10.0277 2.89668 9.79648C3.06543 9.56523 3.1498 9.29961 3.1498 8.99961C3.1498 8.69961 3.06543 8.43398 2.89668 8.20273C2.72793 7.97148 2.5058 7.80992 2.2303 7.71805C2.10405 7.69505 2.00074 7.63761 1.92037 7.54573C1.83999 7.45386 1.7998 7.34473 1.7998 7.21836V4.94605C1.7998 4.5758 1.93199 4.25886 2.19637 3.99523C2.46074 3.73148 2.77855 3.59961 3.1498 3.59961H14.8498C15.2211 3.59961 15.5389 3.73155 15.8032 3.99542C16.0676 4.2593 16.1998 4.57648 16.1998 4.94698V7.22061C16.1998 7.34411 16.1596 7.45198 16.0792 7.54423C15.9989 7.63661 15.8956 7.69436 15.7693 7.71748C15.4938 7.80973 15.2717 7.97148 15.1029 8.20273C14.9342 8.43398 14.8498 8.69961 14.8498 8.99961C14.8498 9.29961 14.9342 9.56523 15.1029 9.79648C15.2717 10.0277 15.4938 10.1893 15.7693 10.2812C15.8956 10.3042 15.9989 10.3616 16.0792 10.4535C16.1596 10.5454 16.1998 10.6545 16.1998 10.7809V13.0532C16.1998 13.4234 16.0676 13.7404 15.8032 14.004C15.5389 14.2677 15.2211 14.3996 14.8498 14.3996H3.1498ZM3.1498 13.0496H14.8498V11.3434C14.4498 11.1059 14.1248 10.7809 13.8748 10.3684C13.6248 9.95586 13.4998 9.49961 13.4998 8.99961C13.4998 8.49961 13.6248 8.04336 13.8748 7.63086C14.1248 7.21836 14.4498 6.89336 14.8498 6.65586V4.94961H3.1498V6.65586C3.5498 6.89336 3.8748 7.21836 4.1248 7.63086C4.3748 8.04336 4.4998 8.49961 4.4998 8.99961C4.4998 9.49961 4.3748 9.95586 4.1248 10.3684C3.8748 10.7809 3.5498 11.1059 3.1498 11.3434V13.0496Z" fill="currentColor"/>
  </svg>
);

const NAV_ICON_COMPONENTS = {
  dashboard: DashboardOutlined,
  task: TaskOutlined,
  assignment_turned_in: AssignmentTurnedInOutlined,
  event_available: BeachAccessOutlined,
  eod: DateRangeOutlined,
  store: StoreOutlined,
  handshake: HandshakeOutlined,
  account_balance_wallet: AccountBalanceWalletOutlined,
  assignment: AssignmentOutlined,
  texture: TextureOutlined,
  palette: PaletteOutlined,
  view_kanban: ViewKanbanOutlined,
  shopping_cart: ShoppingCartOutlined,
  folder: FolderOutlined,
  notifications: NotificationsOutlined,
  bar_chart: BarChartOutlined,
  people: PeopleOutlined,
  history: HistoryOutlined,
  settings: SettingsOutlined,
};


export const NavIcon = ({ name, style = { fontSize: 20 } }) => {
  if (name === "confirmation_number") return <TicketIcon />;
  if (name === "lab_profile") return <LabProfileIcon />;
  if (name === "shield_locked") return <ShieldLockedIcon />;
  const IconComponent = NAV_ICON_COMPONENTS[name];
  if (!IconComponent) return null;
  return <IconComponent style={style} />;
};

const SideNav = ({
  logo = kt,
  userName,
  userRole,
  defaultActiveItem = "dashboard",
  activeItem: controlledActiveItem,
  onItemChange,
  navigations = manufacturerNavigations,
  navTheme = "manufacturer",
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const handleLogout = useLogout();
  const loginUser = useSelector((state) => state.auth?.loginUser);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [internalActiveItem, setInternalActiveItem] = useState(defaultActiveItem);
  const [expandedItem, setExpandedItem] = useState(null);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const isControlled = controlledActiveItem !== undefined;

  const userAccessControl = loginUser?.accessControl || loginUser?.role?.accessControl || null;
  const workspaceName = useSelector((state) => (navTheme === "brand" ? state.brand?.profile?.name : state.manufacturer?.profile?.name));
  const menuItems = useMemo(
    () => filterNavigationsByAccessControl(navigations, userAccessControl),
    [navigations, userAccessControl],
  );
  const urlActiveId = findActiveNavItem(menuItems, location.pathname)?.id;
  const activeItem = isControlled ? controlledActiveItem : (urlActiveId ?? internalActiveItem);

  const truncateText = (value = "", maxLength = 20) => {
    const text = String(value ?? "");
    return text.length <= maxLength ? text : `${text.slice(0, maxLength).trimEnd()}…`;
  };

  useEffect(() => {
    if (isDesktop) setIsMobileOpen(false);
  }, [isDesktop]);

  useEffect(() => {
    if (isCollapsed) setExpandedItem(null);
  }, [isCollapsed]);

  useEffect(() => {
    const activeParent = menuItems.find((item) => item.children?.some((child) => isLinkActive(location.pathname, child)));
    if (activeParent) setExpandedItem(activeParent.id);
  }, [location.pathname, menuItems]);

  const closeMobileDrawer = () => {
    if (!isDesktop) setIsMobileOpen(false);
  };

  const handleItemChange = (id) => {
    if (!isControlled) setInternalActiveItem(id);
    onItemChange?.(id);
  };

  const handleParentClick = (item) => {
    if (item.children?.length) {
      if (isCollapsed) {
        setIsCollapsed(false);
        setExpandedItem(item.id);
        return;
      }
      setExpandedItem((previous) => (previous === item.id ? null : item.id));
      return;
    }

    if (item.link) navigate(item.link);
    handleItemChange(item.id);
    closeMobileDrawer();
  };

  const handleChildClick = (child) => {
    if (child.link) navigate(child.link);
    handleItemChange(child.id);
    closeMobileDrawer();
  };

  const isBrandTheme = navTheme === "brand";

  const mainNavItems = useMemo(() => {
    if (!isBrandTheme) return menuItems;
    return menuItems.filter((item) => item.id !== "team" && item.id !== "settings" && item.id !== "audit");
  }, [menuItems, isBrandTheme]);

  const brandBottomItems = useMemo(() => {
    if (!isBrandTheme) return [];
    const teamItem = menuItems.find((item) => item.id === "team");
    const settingsItem = menuItems.find((item) => item.id === "settings");
    const auditItem = menuItems.find((item) => item.id === "audit");
    return [teamItem, settingsItem, auditItem].filter(Boolean);
  }, [menuItems, isBrandTheme]);

  const drawerIsCollapsed = isDesktop && isCollapsed;
  const renderMenuItem = (item) => {
    const hasChildren = item.children?.length > 0;
    const isExpanded = expandedItem === item.id;
    const isParentActive = activeItem === item.id || item.children?.some((child) => activeItem === child.id);
    const isActiveLeaf = isParentActive && !hasChildren;
    const itemButton = (
      <button
        type="button"
        className={`${styles.menuItem} ${isParentActive ? styles.activeItem : ""} ${drawerIsCollapsed ? styles.collapsedMenuItem : ""}`}
        onClick={() => handleParentClick(item)}
        aria-current={isActiveLeaf ? "page" : undefined}
        aria-expanded={hasChildren ? isExpanded : undefined}
      >
        <span className={styles.iconWrapper}>
          <NavIcon name={item.icon} />
        </span>
        {!drawerIsCollapsed && <span className={styles.menuTitle}>{truncateText(item.title)}</span>}
        {!drawerIsCollapsed && hasChildren && (
          <span className={styles.expandIcon} aria-hidden="true">
            {isExpanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </span>
        )}
      </button>
    );

    return (
      <React.Fragment key={item.id}>
        {drawerIsCollapsed ? <Tooltip title={item.title} placement="right">{itemButton}</Tooltip> : itemButton}
        {!drawerIsCollapsed && hasChildren && isExpanded && (
          <div className={styles.subMenu}>
            {item.children.map((child) => {
              const isChildActive = activeItem === child.id;
              return (
                <button
                  key={child.id}
                  type="button"
                  className={`${styles.subMenuItem} ${isChildActive ? styles.subMenuItemActive : ""}`}
                  onClick={() => handleChildClick(child)}
                  aria-current={isChildActive ? "page" : undefined}
                >
                  <span className={styles.subMenuIndicator} />
                  <span className={styles.subMenuTitle}>{truncateText(child.title)}</span>
                </button>
              );
            })}
          </div>
        )}
      </React.Fragment>
    );
  };

  return (
    <>
      {!isDesktop && !isMobileOpen && (
        <IconButton
          aria-label="Open navigation"
          className={`${styles.mobileMenuButton} ${navTheme === "brand" ? styles.brandMobileMenuButton : ""}`}
          onClick={() => setIsMobileOpen(true)}
        >
          <MenuIcon />
        </IconButton>
      )}

      <Drawer
        className={drawerIsCollapsed ? styles.drawerCollapsed : styles.drawer}
        classes={{ paper: `${styles.drawerPaper} ${drawerIsCollapsed ? styles.drawerPaperCollapsed : ""}` }}
        variant={isDesktop ? "permanent" : "temporary"}
        open={isDesktop ? true : isMobileOpen}
        onClose={closeMobileDrawer}
        ModalProps={isDesktop ? undefined : { keepMounted: true }}
      >
        <aside className={`${styles.container} ${navTheme === "brand" ? styles.brandTheme : navTheme === "manufacturer" ? styles.manufacturerTheme : ""} ${drawerIsCollapsed ? styles.collapsedContainer : ""}`}>
          <div className={styles.top}>
            <div className={styles.brandWrapper}>
              <div className={styles.logoWrapper}>
                {logo ? <img src={logo} alt="Kriha Teams" className={styles.logoImage} /> : <span className={styles.logoText}>K</span>}
              </div>
              {!drawerIsCollapsed && <img src={krihaTeamsWordmark} alt="Kriha Teams" className={styles.titleImage} />}
              <IconButton
                aria-label={isDesktop ? (isCollapsed ? "Expand navigation" : "Collapse navigation") : "Close navigation"}
                className={styles.collapseButton}
                onClick={() => (isDesktop ? setIsCollapsed((previous) => !previous) : closeMobileDrawer())}
              >
                <CollapseToggleIcon isCollapsed={isDesktop && isCollapsed} strokeColor={navTheme === "brand" ? "#5c5a54" : "white"} />
              </IconButton>
            </div>

            {!drawerIsCollapsed && (
              <div className={styles.manufacturerHeader}>
                <div className={styles.manufacturerLabel}>{navTheme === "brand" ? "BRAND" : "MANUFACTURER"}</div>
                <div className={styles.manufacturerTitle}>{workspaceName || "—"}</div>
              </div>
            )}

            <nav className={styles.wrapper} aria-label="Primary navigation">
              {mainNavItems.map(renderMenuItem)}
            </nav>
          </div>

          {isBrandTheme && brandBottomItems.length > 0 && (
            <div className={styles.brandBottomSection}>
              {brandBottomItems.map(renderMenuItem)}
            </div>
          )}

          {/* <div className={styles.bottom}>
            <button
              type="button"
              className={styles.profileWrapper}
              onClick={() => {
                navigate("/dashboard/settings");
                closeMobileDrawer();
              }}
            >
              <span className={styles.avatar}>
                {avatarImage ? <img className={styles.avatarImage} src={avatarImage} alt="" /> : <PersonIcon />}
              </span>
              {!drawerIsCollapsed && (
                <span className={styles.profileDetails}>
                  <span className={styles.userName} title={displayName}>{truncateText(displayName)}</span>
                  {displayRole && <span className={styles.userRole} title={displayRole}>{truncateText(displayRole)}</span>}
                </span>
              )}
            </button>

            {!drawerIsCollapsed && (
              <IconButton
                aria-label="Logout"
                className={styles.logoutButton}
                onClick={() => setIsLogoutModalOpen(true)}
              >
                <LogoutRounded />
              </IconButton>
            )}
          </div> */}
        </aside>
      </Drawer>

      <LogoutModal
        isOpen={isLogoutModalOpen}
        onClose={() => setIsLogoutModalOpen(false)}
        onConfirm={() => {
          setIsLogoutModalOpen(false);
          handleLogout();
        }}
      />
    </>
  );
};

export default SideNav;

